/**
 * Which mounted forms hold unsaved edits, app-wide.
 *
 * `useFormSafety` registers here while its form is dirty, so code that is about
 * to unmount a page for a reason the page did not choose — an access change
 * that closes the current route — can ask first instead of silently throwing
 * the seller's typing away (see `RouteAdmission`).
 */
const dirtyForms = new Set<symbol>();

export function setFormDirty(id: symbol, isDirty: boolean): void {
  if (isDirty) dirtyForms.add(id);
  else dirtyForms.delete(id);
}

export function hasDirtyForms(): boolean {
  return dirtyForms.size > 0;
}
